var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row mt-lg-0 mt-3" },
    [
      _c("transition", { attrs: { name: "fade-right" } }, [
        _vm.mediumResImagesLoaded < _vm.portfolioImages.length - 2
          ? _c("div", { staticClass: "high-res-images-loader" }, [
              _c("div", { staticClass: "value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      Math.round(
                        (_vm.mediumResImagesLoaded /
                          _vm.portfolioImages.length) *
                          100
                      )
                    ) + "%"
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.mediumResImagesLoaded) +
                      "/" +
                      _vm._s(_vm.portfolioImages.length)
                  ),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("of images")]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-16 align-items-start",
          attrs: { "data-scroll-container": "" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "row no-gutters align-items-lg-start align-items-end w-100",
              attrs: { "data-scroll-section": "", id: "stick" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-xxl-14 col-16 mt-xxl-15 mt-lg-10 align-self-lg-end",
                  class: {
                    "col-lg-5 offset-xxl-2 offset-lg-3":
                      _vm.$store.state.privatePortfolio.length > 1,
                    "col-lg-8": _vm.$store.state.privatePortfolio.length <= 1,
                  },
                },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("p", { staticClass: "username pl-xl-3 pl-lg-1" }, [
                      _c("b", { staticClass: "font-weight-bold" }, [
                        _vm._v("Hello,"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.user.name) + " //\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-logout ml-2",
                        attrs: { type: "button" },
                        on: { click: _vm.logout },
                      },
                      [_vm._v("\n            LOGOUT\n          ")]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.$store.state.privatePortfolio.length > 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-xxl-2 col-lg-3 col-11 order-xxl-2 order-lg-3 lg-sticky pt-lg-sticky",
                      attrs: {
                        "data-scroll": "",
                        "data-scroll-target": "#stick",
                        "data-scroll-sticky": "",
                      },
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "portfolio-menu" },
                        _vm._l(
                          _vm.$store.state.privatePortfolio,
                          function (category, index) {
                            return _c(
                              "li",
                              { key: index },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "client-area",
                                        params: { category: category.slug },
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v(_vm._s(category.title))])]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "order-xxl-3 order-lg-4 mt-5",
                  class: {
                    "col-lg-13": _vm.$store.state.privatePortfolio.length > 1,
                    "col-xxl-15 col-16":
                      _vm.$store.state.privatePortfolio.length <= 1,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "masonry",
                      class: [
                        "columns-" + _vm.masonryColumns,
                        { active: _vm.showMasonry },
                      ],
                    },
                    _vm._l(_vm.portfolioImages, function (image, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "masonry-item",
                          style: { "grid-row-end": "span " + image.low.height },
                          attrs: {
                            "data-fancybox": "gallery",
                            "data-caption": image.high.title,
                            href: image.high.src,
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "img-low",
                            attrs: { src: image.low.src },
                            on: { load: _vm.onLowResImageLoad },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "img-loader" }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-medium",
                            attrs: { "data-src": image.medium },
                            on: { load: _vm.showMediumResImage },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }